import { CheckCircle2 } from "lucide-react";
import { Reveal, PageHero, SectionHeading, Eyebrow, CTABand, ICONS } from "@/components/Common";

const ServicePage = ({ service }) => {
  const Icon = ICONS[service.icon];
  return (
    <>
      <PageHero crumb={`Home — Services — ${service.title}`} title={service.title} subtitle={service.short} />

      <section className="py-16 sm:py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <Reveal className="relative order-2 lg:order-1">
            <div className="absolute -top-5 -left-5 w-full h-full border-2 border-gold pointer-events-none" />
            <div className="relative overflow-hidden">
              <img src={service.image} alt={service.title} className="w-full h-[380px] sm:h-[460px] object-cover" />
              <div className="absolute bottom-0 left-0 bg-navy px-6 py-4 flex items-center gap-3">
                <Icon size={20} className="text-gold" />
                <span className="font-heading font-bold text-white text-sm tracking-wide">{service.title}</span>
              </div>
            </div>
          </Reveal>
          <div className="order-1 lg:order-2">
            <Reveal>
              <Eyebrow>Overview</Eyebrow>
              <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy mt-4 leading-tight">
                {service.title} by Daksh
              </h2>
            </Reveal>
            {service.intro.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <p className="mt-5 text-slate-600 leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 lg:py-24 bg-[#FAFAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            eyebrow="What We Provide"
            title={`${service.title} — Scope of Services`}
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {service.offerings.map((o, i) => (
              <Reveal key={o.title} delay={(i % 3) * 0.08}>
                <div className="bg-white border border-slate-200 p-7 h-full transition-all hover:border-gold hover:-translate-y-1 hover:shadow-lg hover:shadow-navy/5" data-testid={`offering-${service.slug}-${i}`}>
                  <CheckCircle2 size={22} className="text-gold-hover" />
                  <h3 className="font-heading text-lg font-semibold text-navy mt-4">{o.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{o.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading
            eyebrow="Workforce Categories"
            title="Personnel Categories Available"
            desc="Specific roles and categories are finalized based on your site's operational requirement."
          />
          <Reveal>
            <div className="flex flex-wrap gap-3" data-testid="workforce-categories">
              {service.categories.map((c) => (
                <span key={c} className="border border-slate-300 bg-white px-5 py-2.5 text-sm font-medium text-navy tracking-wide transition-colors hover:border-gold hover:bg-gold-soft">
                  {c}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <CTABand
        title={`Need ${service.title.toLowerCase()} for your organization?`}
        desc="Share your requirement and our team will respond with a structured deployment plan and quotation."
      />
    </>
  );
};

export default ServicePage;
